import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Avatar from 'shared-web/src/components/Avatar'

import compose from 'recompose/compose'
import withProps from 'recompose/withProps'
import withHandlers from 'recompose/withHandlers'
import lifecycle from 'recompose/lifecycle'

import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as PlaybookModels from 'app/modules/playbook/models'
import { RoutingType } from 'app/modules/playbook/constants'
import * as MeetingSelectors from 'app/modules/meetings/selectors'
import * as UserSelectors from 'app/modules/user/selectors'
import * as ClassificationSelectors from 'app/modules/classification/selectors'

import GoalRoutingModal from './component'

const mapStateToProps = state => ({
  goal: PlaybookSelectors.currentGoal(state),
  classificationOptions: ClassificationSelectors.classificationOptions(state),
  selectedGoalRoutingOption: PlaybookSelectors.selectedGoalRoutingOption(state),
  isSingleRoutingSelected: PlaybookSelectors.isSingleRoutingSelected(state),
  isGlobalRoutingSelected: PlaybookSelectors.isGlobalRoutingSelected(state),
  isGroupRoutingSelected: PlaybookSelectors.isGroupRoutingSelected(state),
  isNoRoutingSelected: PlaybookSelectors.isNoRoutingSelected(state),
  goalRoutingView: PlaybookSelectors.goalRoutingView(state),
  orgUsersById: UserSelectors.orgUsersById(state),
  calendarConnectedAgentIds: MeetingSelectors.getAgentIdsWithConnectedCalendars(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      hideGoalRoutingModal: PlaybookActions.hideGoalRoutingModal,
      selectGoalRoutingOptionUI: PlaybookActions.selectGoalRoutingOptionUI,
      saveGoalRoutingOption: PlaybookActions.saveGoalRoutingOption,
      setGoalRoutingView: PlaybookActions.setGoalRoutingView,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentWillMount() {
      const { goal, actions: { selectGoalRoutingOptionUI }} = this.props
      selectGoalRoutingOptionUI(goal.get('routing') || PlaybookModels.RoutingOption())
    },
  }),
  withProps(props => ({
    viewSingleRoutingOptions: props.goalRoutingView === RoutingType.SINGLE,
    viewGroupRoutingOptions: props.goalRoutingView === RoutingType.GROUP,
    viewGlobalRoutingOptions: false && props.goalRoutingView === RoutingType.GLOBAL, // false until we  build out the UI...
    classificationDetails: props.classificationOptions.find(
      classification => classification.value === props.goal.classification.get('classificationId')
    ),
    orgUsersOptions: props.orgUsersById.toArray().map(user => {
      const isCalendarConnected = props.calendarConnectedAgentIds.includes(user.id)
      return {
        value: user.id,
        user: user,
        label: (
          <div className="flex routing-option">
            <Avatar size="small" user={user} />
            {user.name || user.email} {isCalendarConnected ? ' 📅' : ''}
          </div>
        ),
      }
    }),
    selectedRoutingUsers: props.selectedGoalRoutingOption.userIds
      ? props.selectedGoalRoutingOption.userIds instanceof Array
        ? props.selectedGoalRoutingOption.userIds
        : props.selectedGoalRoutingOption.userIds.toJS()
      : null,
    firstUser: props.orgUsersById.first(),
  })),
  withHandlers({
    onCloseClick: props => () => {
      const {
        goal: { id },
        actions: { hideGoalRoutingModal, saveGoalRoutingOption },
        selectedGoalRoutingOption,
      } = props
      saveGoalRoutingOption({ goalId: id, goalRoutingOption: selectedGoalRoutingOption })
      hideGoalRoutingModal()
    },
    onCancelClick: props => () => {
      const { actions: { hideGoalRoutingModal, setGoalRoutingView }} = props
      hideGoalRoutingModal()
      setGoalRoutingView(null)
    },
    resetRoutingView: props => () => {
      const { actions: { setGoalRoutingView }} = props
      setGoalRoutingView(null)
    },
    handleSelectGroup: props => () => {
      const {
        orgUsersById,
        goal,
        actions: { selectGoalRoutingOptionUI, setGoalRoutingView },
      } = props
      selectGoalRoutingOptionUI(
        PlaybookModels.GroupRoutingOption({
          userIds: goal.getIn(['routing', 'userIds']) || null,
        })
      )
      setGoalRoutingView(RoutingType.GROUP)
    },
    handleSelectSingle: props => () => {
      const {
        orgUsersById,
        goal,
        actions: { selectGoalRoutingOptionUI, setGoalRoutingView },
      } = props
      const userId = goal.getIn(['routing', 'userId']) || orgUsersById.first().id
      selectGoalRoutingOptionUI(
        PlaybookModels.SingleRoutingOption({
          userId,
        })
      )
      setGoalRoutingView(RoutingType.SINGLE)
    },
    handleSelectGlobal: props => () => {
      const { actions: { selectGoalRoutingOptionUI, setGoalRoutingView }} = props
      selectGoalRoutingOptionUI(
        PlaybookModels.RoutingOption({
          type: RoutingType.GLOBAL,
        })
      )
      setGoalRoutingView(RoutingType.GLOBAL)
    },
    handleSelectNoRouting: props => () => {
      const { actions: { selectGoalRoutingOptionUI, setGoalRoutingView }} = props
      selectGoalRoutingOptionUI(
        PlaybookModels.RoutingOption({
          type: RoutingType.NONE,
        })
      )
      setGoalRoutingView(null)
    },
    onSingleRouteUserSelect: props => ref => {
      props.actions.selectGoalRoutingOptionUI(
        PlaybookModels.SingleRoutingOption({
          userId: ref.value,
        })
      )
    },
    onGroupRouteUserSelect: props => ref => {
      props.actions.selectGoalRoutingOptionUI(
        PlaybookModels.GroupRoutingOption({
          userIds: ref.map(elt => elt.value),
        })
      )
    },
  })
)(GoalRoutingModal)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/GoalRoutingModal/index.js